module.exports = __webpack_public_path__ + "img/KLA_Logo_100_Jahre.21d24b43.jpg";